import React, { useState } from "react";
import { Typography, Link, useTheme, useMediaQuery } from "@mui/material";

const MAX_LENGTH = 100;

const ProductDescription = ({ description = "" }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isLong = description.length > MAX_LENGTH;
  const preview = description.slice(0, MAX_LENGTH) + "...";

  const handleToggle = (e) => {
    e.preventDefault();
    setExpanded((prev) => !prev);
  };

  const showTruncated = !isMobile && isLong && !expanded;

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      sx={{ mb: 1 }}>
      {showTruncated ? preview : description}{" "}
      {!isMobile && isLong && (
        <Link
          component="button"
          onClick={handleToggle}
          underline="hover"
          sx={{ fontSize: "0.8rem" }}>
          {expanded ? "less" : "more"}
        </Link>
      )}
    </Typography>
  );
};

export default ProductDescription;
